function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import PouchDB from 'pouchdb-browser';
import PouchDBFind from 'pouchdb-find';
import { Operator as FilterOperator, Type as FilterType } from '@deephaven/filters';
import Log from '@deephaven/log';
import { PromiseUtils } from '@deephaven/utils';
var log = Log.module('PouchStorageTable');
var DB_PREFIX = 'Deephaven.';
PouchDB.plugin(PouchDBFind);
export function makePouchFilter(type, value) {
  switch (type) {
    case FilterType.in:
    case FilterType.contains:
      return {
        $regex: new RegExp("".concat(value)).toString()
      };
    case FilterType.inIgnoreCase:
      return {
        $regex: new RegExp("".concat(value), 'i').toString()
      };
    case FilterType.eq:
      return {
        $eq: value
      };
    case FilterType.notEq:
      return {
        $ne: value
      };
    case FilterType.greaterThan:
      return {
        $gt: value
      };
    case FilterType.greaterThanOrEqualTo:
      return {
        $gte: value
      };
    case FilterType.lessThan:
      return {
        $lt: value
      };
    case FilterType.lessThanOrEqualTo:
      return {
        $lte: value
      };
    case FilterType.startsWith:
      return {
        $regex: new RegExp("^".concat(value, ".*")).toString()
      };
    default:
      throw new Error("Unsupported type: ".concat(type));
  }
}
function makePouchSelectorFromConfig(config) {
  var filterItems = config.filterItems,
    filterOperators = config.filterOperators;
  var filter = null;
  for (var i = 0; i < filterItems.length; i += 1) {
    var filterItem = filterItems[i];
    var columnName = filterItem.columnName,
      type = filterItem.type,
      value = filterItem.value;
    var newFilter = {
      [columnName]: makePouchFilter(type, value)
    };
    if (i === 0) {
      filter = newFilter;
    } else if (filter !== null && i - 1 < filterOperators.length) {
      var filterOperator = filterOperators[i - 1];
      if (filterOperator === FilterOperator.and) {
        filter = {
          $and: [filter, newFilter]
        };
      } else if (filterOperator === FilterOperator.or) {
        filter = {
          $or: [filter, newFilter]
        };
      } else {
        throw new Error("Unexpected filter operator ".concat(filterOperator, ", ").concat(newFilter));
      }
    }
  }
  if (filter == null) {
    throw new Error("Invalid filter config ".concat(config));
  }
  return filter;
}
function selectorWithFilters() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    $and: [...filters.map(filter => makePouchSelectorFromConfig(filter)), {
      name: {
        $gt: null
      }
    }, {
      id: {
        $gt: null
      }
    }]
  };
}
function sortWithConfigs(sorts) {
  var _sorts$map;
  var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return [{
    id: reverse ? 'desc' : 'asc'
  }, ...((_sorts$map = sorts === null || sorts === void 0 ? void 0 : sorts.map(sort => ({
    [sort.column]: sort.direction
  }))) !== null && _sorts$map !== void 0 ? _sorts$map : [])];
}
export class PouchStorageTable {
  constructor(databaseName, dbOptions) {
    _defineProperty(this, "db", void 0);
    _defineProperty(this, "changes", void 0);
    _defineProperty(this, "listeners", []);
    _defineProperty(this, "itemListeners", new Map());
    _defineProperty(this, "currentSize", 0);
    _defineProperty(this, "currentViewport", void 0);
    _defineProperty(this, "currentReverse", false);
    _defineProperty(this, "currentFilter", null);
    _defineProperty(this, "currentSort", null);
    _defineProperty(this, "infoUpdatePromise", void 0);
    _defineProperty(this, "viewportUpdatePromise", void 0);
    _defineProperty(this, "currentViewportData", void 0);
    this.db = new PouchDB("".concat(DB_PREFIX).concat(databaseName), dbOptions);

    // Need to set `_remote` to false to remove deprecation warnings: https://github.com/pouchdb/pouchdb/issues/6106
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-underscore-dangle
    this.db._remote = false;
    this.listenForChanges();
    this.db.createIndex({
      index: {
        fields: ['id', 'name']
      }
    });
    this.refreshInfo();
  }

  /**
   * Listen for db changes. This can be cancelled by calling
   * `this.changes?.cancel()`
   */
  listenForChanges() {
    this.changes = this.db.changes({
      live: true,
      since: 'now',
      include_docs: true
    }).on('change', this.dbUpdate.bind(this));
  }
  onUpdate(callback) {
    this.listeners = [...this.listeners, callback];
    return () => {
      this.listeners = this.listeners.filter(other => other !== callback);
    };
  }
  onItemUpdate(id, listener) {
    if (!this.itemListeners.has(id)) {
      this.itemListeners.set(id, []);
    }
    this.itemListeners.set(id, [...this.itemListeners.get(id), listener]);
    this.refreshItem(id);
    return () => {
      this.itemListeners.set(id, this.itemListeners.get(id).filter(other => other !== listener));
    };
  }
  close() {
    this.listeners = [];
  }
  get size() {
    return this.currentSize;
  }
  get viewport() {
    return this.currentViewport;
  }
  setReversed(reversed) {
    this.currentReverse = reversed;
    this.currentViewportData = undefined;
    this.refreshData();
  }
  setViewport(viewport) {
    this.currentViewport = viewport;
    this.refreshInfo();
    this.refreshData();
  }
  setSorts(config) {
    this.currentSort = config;
    this.currentViewportData = undefined;
    this.refreshData();
  }
  setFilters(config) {
    this.currentFilter = config;
    this.currentViewportData = undefined;
    this.refreshInfo();
    this.refreshData();
  }
  get data() {
    return this.currentViewportData;
  }
  getViewportData() {
    var _this = this;
    return _asyncToGenerator(function* () {
      var _this$viewportUpdateP;
      if (!_this.viewportUpdatePromise) {
        _this.refreshData();
      }
      return (_this$viewportUpdateP = _this.viewportUpdatePromise) !== null && _this$viewportUpdateP !== void 0 ? _this$viewportUpdateP : Promise.resolve({
        items: [],
        offset: 0
      });
    })();
  }
  put(item) {
    var _this2 = this;
    return _asyncToGenerator(function* () {
      // Put the item ID in both the _id and the id slot
      // PouchDB uses _id everywhere, StorageTable just uses `id` though
      var newItem = _objectSpread(_objectSpread({}, item), {}, {
        _id: item.id
      });
      yield _this2.db.put(newItem);
      return newItem;
    })();
  }
  sendUpdate() {
    var _this$currentViewport;
    // Retain a reference to it in case a listener gets removed while sending an update
    var listeners = this.listeners;
    var data = (_this$currentViewport = this.currentViewportData) !== null && _this$currentViewport !== void 0 ? _this$currentViewport : {
      items: [],
      offset: 0
    };
    for (var i = 0; i < listeners.length; i += 1) {
      listeners[i](data);
    }
  }
  sendItemUpdate(item) {
    var listeners = this.itemListeners.get(item.id);
    if (listeners !== undefined) {
      for (var i = 0; i < listeners.length; i += 1) {
        listeners[i](item);
      }
    }
  }
  dbUpdate(event) {
    log.debug('Update received', event);
    this.refreshInfo();
    if (event.doc !== undefined) {
      this.sendItemUpdate(event.doc);
    }
    this.refreshData();
  }

  /**
   * Fetch infor for a given selector.
   * @param selector
   */
  fetchInfo(selector) {
    var _this3 = this;
    return _asyncToGenerator(function* () {
      return _this3.db.find({
        selector,
        fields: []
      });
    })();
  }
  refreshInfo() {
    var _this4 = this;
    return _asyncToGenerator(function* () {
      try {
        var _this4$infoUpdateProm, _this4$currentFilter;
        (_this4$infoUpdateProm = _this4.infoUpdatePromise) === null || _this4$infoUpdateProm === void 0 || _this4$infoUpdateProm.cancel();
        _this4.infoUpdatePromise = PromiseUtils.makeCancelable(_this4.fetchInfo(selectorWithFilters((_this4$currentFilter = _this4.currentFilter) !== null && _this4$currentFilter !== void 0 ? _this4$currentFilter : [])));
        var findResult = yield _this4.infoUpdatePromise;
        _this4.currentSize = findResult.docs.length;
        _this4.sendUpdate();
      } catch (e) {
        if (!PromiseUtils.isCanceled(e)) {
          log.error('Unable to refreshInfo', e);
          throw e;
        }
      }
    })();
  }

  /**
   * Fetch data for the given viewport, selector, and sort.
   * @param viewport
   * @param selector
   * @param sort
   */
  fetchViewportData(viewport, selector, sort) {
    var _this5 = this;
    return _asyncToGenerator(function* () {
      return _this5.db.find({
        selector,
        skip: viewport.top,
        limit: viewport.bottom - viewport.top + 1,
        sort,
        fields: ['id', 'name']
      }).then(findResult => ({
        items: findResult.docs,
        offset: viewport.top
      }));
    })();
  }
  refreshData() {
    var _this6 = this;
    return _asyncToGenerator(function* () {
      if (!_this6.currentViewport) {
        return;
      }
      try {
        var _this6$currentFilter, _this6$viewportUpdate;
        var selector = selectorWithFilters((_this6$currentFilter = _this6.currentFilter) !== null && _this6$currentFilter !== void 0 ? _this6$currentFilter : []);
        var sort = sortWithConfigs(_this6.currentSort, _this6.currentReverse);
        (_this6$viewportUpdate = _this6.viewportUpdatePromise) === null || _this6$viewportUpdate === void 0 || _this6$viewportUpdate.cancel();
        _this6.viewportUpdatePromise = PromiseUtils.makeCancelable(_this6.fetchViewportData(_this6.currentViewport, selector, sort));
        var viewportData = yield _this6.viewportUpdatePromise;
        _this6.currentViewportData = viewportData;
        _this6.sendUpdate();
        return viewportData;
      } catch (e) {
        if (!PromiseUtils.isCanceled(e)) {
          log.error('Unable to refreshData', e);
          throw e;
        }
      }
    })();
  }
  refreshItem(id) {
    var _this7 = this;
    return _asyncToGenerator(function* () {
      var findResult = yield _this7.db.find({
        selector: {
          id
        },
        limit: 1
      });
      var item = findResult.docs[0];
      if (item !== undefined) {
        _this7.sendItemUpdate(item);
      }
      return item;
    })();
  }
  getSnapshot(sortedRanges) {
    var _this8 = this;
    return _asyncToGenerator(function* () {
      var itemMap = new Map();
      var sort = [{
        id: _this8.currentReverse ? 'desc' : 'asc'
      }];
      yield Promise.all(sortedRanges.map(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(function* (_ref) {
          var _this8$currentFilter;
          var _ref3 = _slicedToArray(_ref, 2),
            from = _ref3[0],
            to = _ref3[1];
          var limit = to - from + 1;
          return _this8.db.find({
            selector: selectorWithFilters((_this8$currentFilter = _this8.currentFilter) !== null && _this8$currentFilter !== void 0 ? _this8$currentFilter : []),
            skip: from,
            limit,
            sort,
            fields: ['id', 'name']
          }).then(findSnapshotResult => {
            for (var i = 0; i < limit; i += 1) {
              var index = from + i;
              itemMap.set(index, findSnapshotResult.docs[i]);
            }
          });
        });
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }()));
      return itemMap;
    })();
  }
}
export default PouchStorageTable;
//# sourceMappingURL=PouchStorageTable.js.map